import { render, staticRenderFns } from "./AffiliateUserRevenueModal.vue?vue&type=template&id=59694ae8&scoped=true&"
import script from "./AffiliateUserRevenueModal.vue?vue&type=script&lang=babel&"
export * from "./AffiliateUserRevenueModal.vue?vue&type=script&lang=babel&"
import style0 from "./AffiliateUserRevenueModal.vue?vue&type=style&index=0&id=59694ae8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59694ae8",
  null
  
)

export default component.exports